import { createEvent, sample } from 'effector';
import type { GeneralID } from '@types';
import {
  $categoryMap,
  $categoryMapApi,
  $selectedPath,
  $selectedPathApi,
} from '@stores/dataStores';
import { removeCategoryId, removeSceneIdList } from './helpers';

export const moveSceneToCategory = createEvent<{
  id: GeneralID;
  targetId: number;
}>();
sample({
  source: { path: $selectedPath, map: $categoryMap },
  clock: moveSceneToCategory,
  fn: (source, clock) => ({ ...source, ...clock }),
}).watch(({ path, map, id, targetId }) => {
  const curCateId = path.categoryPath[path.categoryPath.length - 1];
  const targetItem = map.get(targetId)!;
  const hasSubCate = targetItem.categoryIds.length > 0;
  const tarId = hasSubCate
    ? targetItem.categoryIds[targetItem.categoryIds.length - 1]
    : targetId;
  $categoryMapApi.update((draft) => {
    removeSceneIdList([id], draft.get(curCateId));
    draft.get(tarId)?.sceneIds.push(id);
  });
  if (id === path.id) {
    $selectedPathApi.update((draft) => {
      if (hasSubCate) {
        draft.categoryPath = [targetId, tarId];
      } else {
        draft.categoryPath = [targetId];
      }
    });
  }
});

export const moveSceneToSubCategory = createEvent<{
  id: GeneralID;
  targetId: number;
}>();
sample({
  source: $selectedPath,
  clock: moveSceneToSubCategory,
  fn: (path, clock) => ({ path, ...clock }),
}).watch(({ path, id, targetId }) => {
  const curCateId = path.categoryPath[1];
  $categoryMapApi.update((draft) => {
    removeSceneIdList([id], draft.get(curCateId));
    draft.get(targetId)?.sceneIds.push(id);
  });
  if (id === path.id) {
    $selectedPathApi.update((draft) => {
      draft.categoryPath[1] = targetId;
    });
  }
});

export const moveSubCategoryToCategory = createEvent<{
  id: number;
  targetId: number;
}>();
sample({
  source: { path: $selectedPath, map: $categoryMap },
  clock: moveSubCategoryToCategory,
  fn: (source, clock) => ({ ...source, ...clock }),
}).watch(({ path, map, id, targetId }) => {
  const curCateId = path.categoryPath[0];
  const targetItem = map.get(targetId)!;
  const hasSubCate = targetItem.categoryIds.length > 0;
  $categoryMapApi.update((draft) => {
    if (!hasSubCate) {
      draft.get(id)!.sceneIds = [
        ...targetItem.sceneIds,
        ...draft.get(id)!.sceneIds,
      ];
      draft.get(targetId)!.sceneIds = [];
    }
    removeCategoryId(id, draft.get(curCateId));
    draft.get(targetId)?.categoryIds.push(id);
  });

  if (id === path.categoryPath[1]) {
    $selectedPathApi.update((draft) => {
      draft.categoryPath[0] = targetId;
    });
  }
});
